import React, { useState } from "react";

/****
 * checkbox input component in pdf editing page.
 */
function ReceiverCheckbox({ field }) {
  const [isFilled, setFilled] = useState(true);

  const handleCheckChange = (e) => {
    setFilled(false);

    if (!e.target.checked) {
      setFilled(true);
    }

    field.isChecked = e.target.checked;
    field.isFilled = true;
    if (field.isChecked === false) {
      field.isFilled = false;
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        left: field.positionFromParentLeft,
        top: field.positionFromParentTop,
        height: field.height,
        width: field.width,
        border: "1px solid green",
      }}>
      {field.errorMessage && isFilled && (
        <span
          style={{
            position: "absolute",
            top: -40,
            background: "red",
            borderRadius: 5,
            margin: 4,
            padding: 5,
            color: "white",
          }}>
          Required
        </span>
      )}
      <input
        onChange={handleCheckChange}
        placeholder={field.placeholder}
        style={{
          width: "100%",
          height: "100%",
          fontSize: field.fontSize,
        }}
        type='checkbox'
      />
    </div>
  );
}

export default ReceiverCheckbox;
